import React, { useContext } from "react";
import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from "@mui/material";
import GroupApprovers from "../FieldTags/GroupApprovers";
import { UserContext } from "../../context/UserContext";
import pullListLabels from "../../util/PullListLabels";
import ROLES from "../../util/roles";
import HistoryLogElement from "./HistoryLogElement";
import { checkRole } from "../../util/FormUtils";

const InformedConsent = ({ informedConsent, informedConsentApprover, handleConsentChange, shipmentFromRepo, sampleDisposal, pullLists, required }) => {
    const { user } = useContext(UserContext);
    const canEdit = checkRole(user, [ROLES.BIOOPS, ROLES.APPROVER]);

    return (
        <div className="planField">
            <GroupApprovers description={"APPROVER 1"} />
            <FormControl required={required.includes("informedConsent")}>
                <FormLabel className="planRadioTitle">
                    {sampleDisposal === "No" ? pullListLabels.informedConsent : pullListLabels.disposalRequest}
                </FormLabel>
                <RadioGroup
                    id="informedConsent-field"
                    name="informedConsent"
                    label={sampleDisposal === "No" ? pullListLabels.informedConsent : pullListLabels.disposalRequest}
                    value={informedConsent}
                    onChange={(e) => handleConsentChange("informedConsent", e.target.value)}
                    row
                >
                    <FormControlLabel
                        value="Yes"
                        control={<Radio disabled={!canEdit} />}
                        label="Yes"
                    />
                    <FormControlLabel
                        value="No"
                        control={<Radio disabled={!canEdit || informedConsentApprover === 'Non-ITN'} />}
                        label="No"
                    />
                    {shipmentFromRepo === "Yes" && (
                        <FormControlLabel
                            value="Non-ITN"
                            control={<Radio disabled={!canEdit} />}
                            label="Non-ITN"
                        />
                    )}
                </RadioGroup>
            </FormControl>
            <HistoryLogElement pullLists={pullLists} label={"informedConsent"} />
        </div>
    );
};

export default InformedConsent;